export default __webpack_public_path__ + "static/media/Logo.dcaead3c.svg";